import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useFetch from "hooks/useFetch";
import "./LinkedinImportCallback.scss";
import Loading from "components/Loading";

const LinkedinImportCallback = () => {
  const location = useLocation();
  const { t } = useTranslation("profile");
  const { post } = useFetch();

  useEffect(() => {
    const handleCallback = async () => {
      const urlParams = new URLSearchParams(location.search);
      const code = urlParams.get("code");

      if (!code) {
        console.error("No code found in URL");
        return;
      }

      try {
        await post("/linkedin_membersnapshot", { code });
      } catch (error) {
        console.error("Error during token exchange:", error);
      }
    };

    handleCallback();
  }, [location, post]);

  return (
    <div className="linkedin-callback">
      <Loading />
      <p className="my-4">{t("linkedin_import_loading")}</p>
    </div>
  );
};

export default LinkedinImportCallback;
